import { formatDate } from 'lib/functions/utils';

export function toDdMmYyyy(issuedDate: string): string {
  if (!issuedDate) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(issuedDate)) {
    const year = issuedDate.slice(0, 4);
    const month = issuedDate.slice(5, 7);
    const day = issuedDate.slice(8, 10);
    return `${day}${month}${year}`;
  }
  if (/^\d{8}$/.test(issuedDate)) {
    return issuedDate;
  }
  return issuedDate;
}

function parseDateString(value: string): Date | null {
  if (!value?.trim()) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (/^\d{8}$/.test(value)) {
    const day = parseInt(value.slice(0, 2), 10);
    const month = parseInt(value.slice(2, 4), 10) - 1;
    const year = parseInt(value.slice(4, 8), 10);
    const d = new Date(year, month, day);
    return isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDateDisplay(value: string): string {
  const date = parseDateString(value);
  if (!date) return '';
  return formatDate(date, 'dd-mm-yyyy');
}
